import React, { useEffect } from "react";
import { useFormikContext } from "formik";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
import {
  PAY_FULL_ARREARS_ROUTE,
  MANAGE_ARREARS_ROUTE,
} from "../IncreaseRepayments/route.constants";
import { PRIVATE_ROUTE } from "../../../../route.constants";
import { useAccount } from "../../../../hooks/client";
import { MoneyInput } from "../../../Forms/components/fields";
import { getCreatePaymentPromiseArrearsEndpoint } from "../../../../services/apiRoutes";
import { withLoanForm } from "../../../../components/fairGoForm/withLoanForm";
import { ManageRepaymentForm } from "../../components/manageRepaymentForm";
import { DatePickerManageRepayment } from "../IncreaseRepayments/components/MakeExtraRepayments/datePickerManageRepayments";
import { Wrapper } from "../IncreaseRepayments/components/loanFormsWithDatePicker.styles";
import { Wrapper as ModalWrapper } from "../../components/manageMyRepaymentModal/manageMyRepaymentModal.styles";
import actions from "../../../../redux/manageRepaymentsForm/actions";
import {
  addDaysAfterToday,
  addBusinessDaysAfterToday,
  getValidDates,
  createWorkDaySelectOptions,
  createRequiredDateDropdownShape,
} from "../IncreaseRepayments/components/MakeExtraRepayments/utils/dateHelpersManageRepayments";
import { useCheckIfFormIsActive } from "../../hooks";
import { FIELD_NAMES } from "../../../../constants/commonConstants";

const ModalMessage = () => {
  return (
    <ModalWrapper>
      <p>Thank you. Your request has been received.</p>
    </ModalWrapper>
  );
};

const validDateTimes = getValidDates(
  addBusinessDaysAfterToday(2),
  addDaysAfterToday(14)
);
const filteredDates = createWorkDaySelectOptions(validDateTimes);

const INITIAL_FORM_STATE = {
  [FIELD_NAMES.PROMISE_FIRST_DATE]: { day: "", month: "", year: "" },
  __clientsideonly__promiseFirstDate: "",
};

const FORM_VALIDATION = Yup.object().shape({
  [FIELD_NAMES.PROMISE_FIRST_DATE]: Yup.object()
    .required("Please select a date")
    .shape(createRequiredDateDropdownShape()),
});

const _PayArrearsDirectDebit = ({ accountId }) => {
  const dispatch = useDispatch();
  const { arrearsValue } = useAccount(accountId) || {};
  const { setFieldValue, isValid } = useFormikContext();

  useEffect(() => {
    setFieldValue(FIELD_NAMES.PROMISE_VALUE, arrearsValue);
    if (isValid === true) {
      dispatch(actions.markFormAsValid());
    } else {
      dispatch(actions.markFormAsInvalid());
    }
  }, [arrearsValue, setFieldValue, isValid, dispatch]);

  return (
    <div className="input-wrapper">
      <MoneyInput
        className="pay-higher-input"
        decimalPlaces={2}
        name={FIELD_NAMES.PROMISE_VALUE}
        title="Full arrears amount"
        label="amount"
        disabled={true}
      />
      <DatePickerManageRepayment
        title="When will you pay?"
        className="start-date-label"
        name={FIELD_NAMES.PROMISE_FIRST_DATE}
        options={filteredDates}
        placeholder="Select Date"
      />
    </div>
  );
};

const PayArrearsDirectDebitForm = withLoanForm(_PayArrearsDirectDebit);

export const PayArrearsDirectDebit = ({ accountId }) => {
  const { isFormValidated } = useSelector(
    (state) => state.manageRepaymentsForm
  );

  const matchManageArrears =
    PRIVATE_ROUTE.MANAGE_REPAYMENTS +
    MANAGE_ARREARS_ROUTE.ARREARS +
    PAY_FULL_ARREARS_ROUTE.DIRECT_DEBIT;

  const isManageArrearsActive = useCheckIfFormIsActive(matchManageArrears);
  const isActive = isManageArrearsActive;

  const buttonText = isFormValidated
    ? "I Agree And Confirm My Request"
    : "Continue"; //if we remove isFormValidated redux state, we can use something like const [buttonText, setButtonText] = useState("CONTINUE"); instead to set the button text

  return (
    <Wrapper>
      <ManageRepaymentForm
        buttonText={buttonText}
        endpoint={getCreatePaymentPromiseArrearsEndpoint(accountId)}
        initialValues={{ ...INITIAL_FORM_STATE }}
        validationSchema={FORM_VALIDATION}
        modalMessage={<ModalMessage />}
        isActive={isActive}
      >
        <PayArrearsDirectDebitForm accountId={accountId} />
      </ManageRepaymentForm>
    </Wrapper>
  );
};
